import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormRecord } from '@angular/forms';
import { Filter } from '../models/filter.model';
import { FilterOption } from '../interfaces/filteroption.interface';

@Injectable()
export class FormBuilderHelper {
  constructor(private fb: FormBuilder) {}

  /**
   * Generates FormRecord component for use in filter form
   * Each filter is a nested FormRecord, each filter option is a FormControl within that FormRecord
   * @param filters {Filter[]}
   * @returns {FormRecord}
   */
  public createFormRecordFromFilters(
    filters: Filter[],
  ): FormRecord<FormRecord<FormControl<boolean>>> {
    const filterGroup = this.fb.nonNullable.record<
      FormRecord<FormControl<boolean>>
    >({});
    filters.forEach((filter: Filter) => {
      const optionGroup = this.fb.nonNullable.record<FormControl<boolean>>({});
      filter.options.forEach((option: FilterOption) => {
        optionGroup.addControl(
          option.name,
          this.fb.nonNullable.control<boolean>({
            value: option.active,
            disabled: option.count <= 0,
          }),
        );
      });
      filterGroup.addControl(filter.name, optionGroup);
    });
    return filterGroup;
  }

  /**
   * Update filter option disabled states
   * @param filters {Filter}
   * @param formRecord {FormRecord}
   */
  public updateFormRecordFromFilters(
    filters: Filter[],
    formRecord: FormRecord<FormRecord<FormControl<boolean>>>,
  ): void {
    filters.forEach((filter: Filter) => {
      filter.options.forEach((option: FilterOption) => {
        const optionControl = formRecord.get(filter.name)?.get(option.name);
        if (optionControl) {
          if (option.count > 0 && optionControl.disabled) {
            optionControl.enable({ onlySelf: true, emitEvent: false });
          } else if (!option.count && !optionControl.disabled) {
            optionControl.disable({ onlySelf: true, emitEvent: false });
          }

          // only works for checkboxes with true/false value!
          if (option.active !== optionControl.value) {
            optionControl.patchValue(option.active, {
              onlySelf: true,
              emitEvent: false,
            });
          }
        }
      });
    });
  }
}
